import React, { useState, useEffect, useRef } from "react";
import "./currentCycleDistributors.scss";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Form } from "antd";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { Sidebar } from "primereact/sidebar";
import { Avatar } from "primereact/avatar";
import { currentCycleDistributors } from "../../../apis/CycleDistributorApi";

const CurrentCycleDistributors = () => {
  const [currentcycleDistributors, setCurrentCycleDistributors] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "distributorId.userId.name": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    "distributorId.areaId.areaName": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    "distributorId.userId.mobile": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    "distributorId.userId.email": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    "distributorId.userId.address": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    "distributorId.userId.cnic": {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
  });

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const loadCurrentCycleDistributors = () => {
    currentCycleDistributors().then((res) => {
      if (res.status === 200) {
        setCurrentCycleDistributors(res.data);
      }
    });
  };

  useEffect(() => {
    loadCurrentCycleDistributors();
  }, []);

  const renderHeader = () => {
    return (
      <div className="table-header tab-adjuster-currentCycleDistributors">
        <h5 className="m-0">Distributors</h5>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Search"
          />
        </span>
      </div>
    );
  };

  const header = renderHeader();

  const representativeBodyTemplate = (rowData) => {
    var imgpath =
      "data:image/jpg;base64, " + rowData.distributorId.userId?.profileImage;
    return (
      <React.Fragment>
        <div className="flex align-items-center m-0 gap-2">
          <div>
            {rowData.distributorId.userId?.profileImage ? (
              <Avatar
                className="mr-2"
                size="large"
                shape="circle"
                image={imgpath}
              />
            ) : (
              <Avatar
                label={rowData?.distributorId.userId?.name
                  ?.charAt(0)
                  .toUpperCase()}
                className="mr-2"
                size="large"
                shape="circle"
              />
            )}
          </div>
          <div>
            <p>{rowData?.distributorId?.userId?.name}</p>
          </div>
        </div>
      </React.Fragment>
    );
  };

  return (
    <div className="layout-main">
      <div className="datatable-doc-demo">
        <div className="card">
          <DataTable
            value={currentcycleDistributors}
            filters={filters}
            filterDisplay="menu"
            responsiveLayout="scroll"
            globalFilterFields={[
              "distributorId.userId.name",
              "distributorId.areaId.areaName",
              "distributorId.userId.mobile",
              "distributorId.userId.email",
              "distributorId.userId.address",
              "distributorId.userId.cnic",
            ]}
            emptyMessage="No distributors found."
            dataKey="id"
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 25]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} distributors"
            header={header}
            className="table-sel "
          >
            <Column
              // selectionMode="single"
              headerStyle={{ width: "3em" }}
            ></Column>

            <Column
              field="distributorId.userId.name"
              header="Name"
              sortable
              filterPlaceholder="Search by distributorId.userId.name"
              style={{ minWidth: "11rem" }}
              body={representativeBodyTemplate}
            />

            <Column
              field="distributorId.areaId.areaName"
              header="Area Name"
              body={(record) => {
                return record.distributorId.areaId.areaName;
              }}
              sortable
              filterPlaceholder="Search by distributorId.areaId.areaName"
              style={{ minWidth: "11rem" }}
            />

            <Column
              field="distributorId.userId.mobile"
              header="Mobile"
              body={(record) => {
                return record.distributorId.userId.mobile;
              }}
              sortable
              filterPlaceholder="Search by distributorId.userId.mobile"
              style={{ minWidth: "11rem" }}
            />

            <Column
              field="distributorId.userId.email"
              header="Email"
              body={(record) => {
                return record.distributorId.userId.email;
              }}
              sortable
              filterPlaceholder="Search by distributorId.userId.email"
              style={{ minWidth: "11rem" }}
            />

            <Column
              field="distributorId.userId.address"
              header="Address"
              body={(record) => {
                return record.distributorId.userId.address;
              }}
              sortable
              filterPlaceholder="Search by distributorId.userId.address"
              style={{ minWidth: "11rem" }}
            />

            <Column
              field="distributorId.userId.cnic"
              header="CNIC"
              body={(record) => {
                return record.distributorId.userId.cnic;
              }}
              sortable
              filterPlaceholder="Search by distributorId.userId.cnic"
              style={{ minWidth: "11rem" }}
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
};

export default CurrentCycleDistributors;
